// extracted by mini-css-extract-plugin
export default {"customBox":"styles_customBox__uU2XC","contentBox":"styles_contentBox__mgxaU","headingBox":"styles_headingBox__UL6pj"};